React = require 'react/addons'
AgeProtectedRoute = require '../../mixins/age-protected-route'
Router = require 'react-router'
VideoPlayer = require './video-player'

module.exports = React.createClass
  displayName: 'Product Video'

  mixins: [AgeProtectedRoute, Router.Navigation]

  propTypes:
    product: React.PropTypes.object
    productIndex: React.PropTypes.number
    video: React.PropTypes.object
    videoIndex: React.PropTypes.number
    onNext: React.PropTypes.func
    onPrev: React.PropTypes.func

  render: ->
    React.createElement("div", {"className": 'product'},
      React.createElement(VideoPlayer, {"key": (@props.product.key), "video": (@props.video), "onClose": (@props.onClose), "onNext": (@props.onNext), "onPrev": (@props.onPrev)}),
      React.createElement("div", {"className": 'product-details'}, (@props.product.description))
    )



/** WEBPACK FOOTER **
 ** ./~/cjsx-loader!./src/scripts/components/shared/product-video.cjsx
 **/